import { getHost } from 'helpers/host';
import isClient from 'helpers/isClient';
/* ---------------------------------------------
 * Types
 * --------------------------------------------- */

export interface FetchProps {
  domain: string;
  query: string;
}

export interface TagesplanScheduleEntry {
  date: string;
  time_slot: string | null;
  location: {
    name: string | null;
    house_nr: number | null;
    ort?: string | null;
  } | null;

  title?: string | null;
  category?: any | null;
  image?: any | null;
  thumbnail?: any | null;
  description?: any[];
}

export interface ApiFetchTagesplanResponse {
  tagesplanUid: string | null;
  termineUid: string | null;
  schedule: TagesplanScheduleEntry[];
}

/* ---------------------------------------------
 * Fetch Tagesplan API
 * --------------------------------------------- */

export const fetchTagesplan = async ({
  domain,
  query,
}: FetchProps): Promise<ApiFetchTagesplanResponse> => {
  try {
    const url = `${getHost(domain)}/api/tagesplanApi${query}`;

    const options: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        'cache-control': 'no-cache',
      },
    };

    if (!isClient()) {
      (options.headers as Record<string, string>).Authorization =
        'Basic ' +
        Buffer.from(`ballenberg:${process.env.BASIC_AUTH_PASSWORD}`).toString('base64');
    }

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`Tagesplan API responded with ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    throw {
      name: 'ApiPrismicError',
      message: error,
    };
  }
};
